import styled from 'styled-components'
import {
  Text as BaseText,
  DropdownWrapper,
  MenuIconButton,
} from '@sketch/components'

import { ReactComponent as Divider } from '@sketch/icons/divider-vertical-2'
import { ReactComponent as ImgDocumentIcon } from '@sketch/icons/img-documents-17'
import { breakpoint } from '@sketch/global-styles'

export const Wrapper = styled(DropdownWrapper)`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  border-radius: 0;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  border: none;

  padding: 10px 12px; /* stylelint-disable-line scales/space */
`

export const DocumentIcon = styled(ImgDocumentIcon)`
  width: 17px;
  height: 17px;
  flex-shrink: 0;
`

export const Text = styled(BaseText)`
  display: inline-flex;
  align-items: center;
  flex-basis: 100%;
`

export const ActionButtonWrapper = styled.div`
  display: flex;
`

export const ActionButton = styled(MenuIconButton)`
  padding: 6px 8px; /* stylelint-disable-line scales/space */
  width: auto;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};

  [role='img'] {
    width: 17px;
    height: 17px;
    flex-shrink: 0;
  }
` as typeof MenuIconButton

export const StyledDivider = styled(Divider)`
  width: 2px;
  margin-right: 8px;
  flex-shrink: 0;
`

export const SelectionBottomSinkWrapper = styled.div`
  position: fixed;
  inset: auto 0 0;
  z-index: 1000;
  margin: auto;

  display: flex;
  justify-content: center;

  width: 100%;

  opacity: 0;
  overflow: hidden;
  transform: translate3d(0, 100%, 0);
  transition:
    opacity 0.3s linear,
    transform 0.3s linear;

  &[data-animation-state='entered'],
  &[data-animation-state='entering'] {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  ${({ theme }) => breakpoint('xs')`
    position: sticky;
    bottom: 20px;
    border-radius: 10px; /* stylelint-disable-line scales/radii */

    width: auto;
    min-width: 400px;

    box-shadow:
      0 0 0 2px ${theme.colors.sketch.D},
      0 2px 6px 0 rgba(0, 0, 0, 0.05);
  `}
`
